import { ReactNode } from "react";
import styles from "./AnalyticsMessage.module.scss";
import { AnalyticsCardType } from "../card/AnalyticsCard";
import { ChartIcon, CheckmarkIcon, WarningIcon } from "../../../../assets/icons";

// Warning and negative share an icon — the tone and the text are what separate them,
// and both of those are always present.
const TONE_ICONS: Record<AnalyticsCardType, ReactNode> = {
	neutral: <ChartIcon />,
	positive: <CheckmarkIcon />,
	warning: <WarningIcon />,
	negative: <WarningIcon />,
};

type Props = {
	tone?: AnalyticsCardType;
	title: string;
	/** Stands in for the tone's own icon — the tint stays whatever the tone says. */
	icon?: ReactNode;
	/** The sentence under the title explaining what to do about it. */
	children: ReactNode;
};

/** One finding, in the tone of how much it matters. */
const AnalyticsMessage = ({ tone = "neutral", title, icon, children }: Readonly<Props>) => (
	<div className={`${styles.message} ${styles[tone]}`}>
		<span className={styles.icon}>{icon ?? TONE_ICONS[tone]}</span>
		<div>
			<p className={styles.title}>{title}</p>
			<div className={styles.body}>{children}</div>
		</div>
	</div>
);

export default AnalyticsMessage;
